function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareLocaleKeys from '../../../../../locales/keys';
var ExternalBillDetailController = /*#__PURE__*/function () {
  function ExternalBillDetailController() {
    _classCallCheck(this, ExternalBillDetailController);
    this._isInitialized = false;
    this.viewModel = {
      EDIT_MODE_ACC_NO_LENGTH: 30,
      localeKeys: CustomerCareLocaleKeys,
      detailData: {}
    };
  }

  //--------------------------------------------------------------------------
  //
  //  Lifecycle Methods
  //
  //--------------------------------------------------------------------------
  return _createClass(ExternalBillDetailController, [{
    key: "$onInit",
    value: function $onInit() {
      this._isInitialized = true;
      this.updateViewModel();
      this.updateAccountNumberLength();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges() {
      this.updateViewModel();
      this.updateAccountNumberLength();
    }

    //--------------------------------------------------------------------------
    //
    //  View Model methods
    //
    //--------------------------------------------------------------------------
  }, {
    key: "updateViewModel",
    value: function updateViewModel() {
      if (!this._isInitialized) {
        return;
      }
      this.viewModel.detailData = this.detailData;
      if (this.detailData) {
        this.viewModel.expiration = {
          fullYear: this.detailData.ExpirationYear,
          month: this.detailData.ExpirationMonth
        };
      } else {
        this.viewModel.expiration = undefined;
      }
    }
  }, {
    key: "updateAccountNumberLength",
    value: function updateAccountNumberLength() {
      if (this.viewModel.detailData && this.viewModel.detailData.AccountNumber) {
        var accountNumberLength = this.viewModel.detailData.AccountNumber.length;
        this.viewModel.detailData.AccountNumber = accountNumberLength > 30 ? this.viewModel.detailData.AccountNumber.substring(accountNumberLength - this.viewModel.EDIT_MODE_ACC_NO_LENGTH, accountNumberLength) : this.viewModel.detailData.AccountNumber;
      }
    }
  }]);
}();
export var ExternalBillDetailComponent = {
  bindings: {
    detailData: '<'
  },
  controller: ExternalBillDetailController,
  template: require('./external.bill.detail.html')
};